import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { img2 } from "../_components/Imagepath";
import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { useFormik, FormikProvider, FieldArray } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { doc, setDoc } from "firebase/firestore"; 
import $ from "jquery";
const AddUser = () => {
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [companyNames, setCompanyNames] = useState([]);
  const [showSelectField, setShowSelectField] = useState(false);
  const [userRole, setUserRole] = useState([]);
  const [menu, setMenu] = useState(false);
  const [locationLoading, setLocationLoading] = useState([]);
  const [modules, setModules] = useState([]);
  const [permission, setPermission] = useState({});

  

  // const firebaseConfig = {
  //   apiKey: "AIzaSyCEioKfhSoorZm7jElZVKzVrs7PoZVieOo",
  //   authDomain: "react-chat-d7fd2.firebaseapp.com",
  //   projectValue: "react-chat-d7fd2",
  //   storageBucket: "react-chat-d7fd2.appspot.com",
  //   messagingSenderValue: "441820348527",
  //   appValue: "1:441820348527:web:1f6fcf08e67939e9864d9a"
  // };
  
  
// Initialize Firebase
//  const app = initializeApp(firebaseConfig);
//  const db = getFirestore(app);

 const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      role: "",
      role_value: "",
      user_position: "",
       user_location: "",
      phone_number: "",
      password: "",
      password_confirmation: "",
      profile_picture: "",
      status: "",
      company_name: "",
      modules: [],
    },
     onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/users/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
           
          $("#form-submit").text("Add User");
          setSubmitting(false);
          delete backendErrors['error'];

          if (response.data.code === 200) {
            // var user =  response.data.data.user;
                  // setDoc(doc(db, "users", user.firebase_token), {
                  //     uvalue: user.firebase_token,
                  //     displayName: user.first_name + " " + user.last_name,
                  //     email: user.email,
                  //     role: user.role.title,
                  //     photoURL: AWS_BUCKET_URL+user.profile_picture
                  // });
                  // setDoc(doc(db, "userChats", user.firebase_token), {});
            
              //setBackendSuccess(response.data.message);
               toast.success(response.data.message);
              setTimeout(() => {
                // actions.resetForm();
                window.location.href = "/users";
              }, 3000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
      setPermission(FindModuleById(1)); 
       console.log(permission);
    axios
      .get(`/helpers/get-roles`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let roles = response.data.data.roles;
            let supplier_typesList = roles.map((ord, index) => ({
              label:  ord.title ,
              value: ord.id,
              key: `supplier-${index}`,
            }));
          setUserRole(supplier_typesList);
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });

      axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;
          let locationslist = locations.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));
          setLocationLoading(locationslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
      
      axios
      .get(`/helpers/all-modules`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.modules;
          let modulees = locations.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `customer-${index}`,
          }));

          setModules(modulees);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }, []);

  const statusOptions = ([
    { value: 0, label: "Select Status" },
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ]);


  const customHandleInput = (event) => {
    const Input_name = event.name;
    delete backendErrors[Input_name];
  };
  
  const handleCustomerFieldChange = (event) => {
    const selectedRole = event.value;

      console.log(selectedRole);


   // handleChange(event);

    if (selectedRole == "3") {
      axios
        .post("/helpers/get-all-customers", {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          let customers = response.data.data.customers;

          if (customers) {
            let customerOptions = customers.map((customer, index) => ({
              label: customer.company_name,
              value: customer.id,
              key: `customer-${index}`,
            }));

            setCompanyNames(customerOptions);
            setShowSelectField(true);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }else{
      setShowSelectField(false);
    }
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Users</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/users">Users</Link>
                    </li>
                    <li className="breadcrumb-item active">Add User</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">User Info</h4>
                    <FormikProvider value={formik}>
                    <form action="#" onSubmit={formik.handleSubmit}>
                      <div className="row justify-content-lg-center">
                        <div className="col-lg-10">
                          <div className="text-center py-5">
                            <label
                              className="avatar avatar-xxl profile-cover-avatar"
                              htmlFor="avatar_upload"
                            >
                              <img
                                className="avatar-img"
                                src={formik.values.profile_picture || img2}
                                alt="Profile Image"
                              />
                              <input
                                type="file"
                                id="avatar_upload"
                                onChange={(event) => {
                                  console.log(event.target);
                                  const file = event.target.files[0];
                                  const reader = new FileReader();
                                  // console.log(reader);
                                  reader.onloadend = () => {
                                    formik.handleChange({
                                      target: {
                                        name: "profile_picture",
                                        value: reader.result,
                                      },
                                    });
                                  };

                                  if (file) {
                                    reader.readAsDataURL(file);
                                  }
                                }}
                              />
                              
                              <span className="avatar-edit">
                                <FeatherIcon
                                  icon="edit-2"
                                  className="avatar-uploader-icon shadow-soft"
                                />
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>First Name</label>
                            <input
                              type="text"
                              name="first_name"
                              value={formik.values.first_name}
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.first_name  && (
                                <span className="form-error mt-1">
                                  {backendErrors.first_name}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              type="text"
                              name="email"
                              value={formik.values.email}
                              className= "form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}  onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.email && (
                                <span className="form-error mt-1">
                                  {backendErrors.email}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group status">
                            <label>Location</label>
                           
                              <Select
                                  className="w-100"
                                  value={locationLoading.find(option => option.value == formik.values.user_location) || null} // Ensure correct format
                                  name="user_location"
                                  onChange={(selectedOption) => {
                                  handleSelectChange("user_location", selectedOption);
                                  //getCustomerGNN(selectedOption.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={locationLoading}
                                  placeholder="Select"


                                // value={formik.values.user_location}
                                // name="user_location"
                                // data={locationLoading.map((shipp) => ({
                                //   value: shipp.id,
                                //   label: shipp.title,
                                // }))}
                                // className="w-100"
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   customHandleInput(e);
                                // }} onBlur={formik.handleBlur}
                                // options={{
                                //   placeholder: "Select a Location",
                                // }}
                              />
                           
                          
                            <small>
                              {backendErrors.user_location && (
                                  <span className="form-error mt-1">
                                    {backendErrors.user_location}
                                  </span>
                                )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Password</label>
                            <input
                              type="text"
                              name="password"
                              value={formik.values.password}
                              className= "form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}  onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.password && (
                                <span className="form-error mt-1">
                                  {backendErrors.password}
                                </span>
                              )}
                            </small>
                          </div>
                     
                          <div className="form-group status">
                            <label>Role</label>
                          
                            <Select
                              className="w-100"
                              value={userRole.find(option => option.value == formik.values.role) || null} // Ensure correct format
                              name="role"
                              onChange={(selectedOption) => {
                              handleSelectChange("role", selectedOption);
                              handleCustomerFieldChange(selectedOption);
                              }}
                              onBlur={formik.handleBlur}
                              options={userRole}
                              placeholder="Select"

                              // value={formik.values.role}
                              // name="role"
                              // data={userRole.map((userRole) => ({
                              //   value: userRole.id,
                              //   label: userRole.title,
                              // }))}
                              // className= "w-100"
                              // onChange={(e) => {
                              //   formik.handleChange(e);
                              //   handleCustomerFieldChange(e);
                              //   customHandleInput(e);
                              // }}
                              // onBlur={formik.handleBlur}
                              // options={{
                              //   placeholder: "Select a User Role",
                              // }}
                            />
                            <small>
                              {backendErrors.role && (
                                <span className="form-error mt-1">
                                  {backendErrors.role}
                                </span>
                              )}
                            </small>
                          </div>
                          {showSelectField && (
                            <div className="form-group status">
                              <label>Company Name</label>
                              {companyNames.length > 0 ? (
                                <Select
                                className="w-100"
                                  value={companyNames.find(option => option.value == formik.values.company_name) || null} // Ensure correct format
                                  name="company_name"
                                  onChange={(selectedOption) => {
                                  handleSelectChange("company_name", selectedOption);
                                  //getCustomerGNN(selectedOption.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={companyNames}
                                  placeholder="Select"

                                  // className= "w-100"
                                  // name="company_name"
                                  // data={companyNames}
                                  // value={formik.values.company_name}
                                  // onChange={(e) => {
                                  //   formik.handleChange(e);
                                  //   customHandleInput(e);
                                  // }}  onBlur={formik.handleBlur}
                                  // options={{
                                  //   placeholder: "Select Company Name",
                                  // }}
                                />
                              ) : (
                                <p>Loading options...</p>
                              )}
                              <small>
                                {backendErrors.company_name  && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_name}
                                    </span>
                                  )}
                              </small>
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Last Name</label>
                            <input
                              type="text"
                              name="last_name"
                              value={formik.values.last_name}
                              className= "form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }} 
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.last_name  && (
                                <span className="form-error mt-1">
                                  {backendErrors.last_name}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Phone</label>
                            <input
                              type="text"
                              name="phone_number"
                              value={formik.values.phone_number}
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }} 
                               onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.phone_number  && (
                                <span className="form-error mt-1">
                                  {backendErrors.phone_number}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Confirm Password</label>
                            <input
                              type="text"
                              name="password_confirmation"
                              value={formik.values.password_confirmation}
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }} 
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.password_confirmation  && (
                                  <span className="form-error mt-1">
                                    {backendErrors.password_confirmation}
                                  </span>
                                )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Position</label>
                            <input
                              type="text"
                              name="user_position"
                              value={formik.values.user_position}
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }} 
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.user_position  && (
                                  <span className="form-error mt-1">
                                    {backendErrors.user_position}
                                  </span>
                                )}
                            </small>
                          </div>
                          <div className="form-group status">
                            <label>Status</label>
                            <Select
                             className="w-100"
                             value={statusOptions.find(option => option.value == formik.values.status) || null} // Ensure correct format
                             name="status"
                             onChange={(selectedOption) => {
                             handleSelectChange("status", selectedOption);
                             //getCustomerGNN(selectedOption.value);
                             }}
                             onBlur={formik.handleBlur}
                             options={statusOptions}
                             placeholder="Select"

                            
                            />
                            <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add Accesses Right
                            </h4>
                           
                          </div>
                        </div>
                        <FieldArray
                          name="modules"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpers.push({
                                    module_name: "",
                                    list: "",
                                    add: "",
                                    update: "",
                                    // view: "",
                                    delete: "",
                                    other_1: "",
                                    other_2: "",
                                    
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.modules.map((friend, index) => (
                                    <tr key={index}>
                                     
                                      <td>
                                        <div className="form-group status">
                                          <label>Select Module</label><br/>
                                          <Select
                                            name={`modules[${index}].module_name`}
                                            options={modules}
                                            value={modules.find(option => option.value == formik.values.modules[index].module_name) || null} // Ensure correct format
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue(`modules[${index}].module_name`, selectedOption.value); // ✅ Store only value in Formik
                                              customHandleInput({
                                                target: {
                                                  name: `modules[${index}].module_name`,
                                                  value: selectedOption.value, // ✅ Ensure only value is passed
                                                },
                                              });
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select"
                                            className="w-100"
                                     />
                                        </div>
                                      </td>
                                   
                                      <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].list`}
                                            value={
                                              formik.values.modules[index]
                                                .list
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> List
                                        </label>
                                      </td>
                                      <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].add`}
                                            value={
                                              formik.values.modules[index]
                                                .add
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> Add
                                        </label>
                                      </td>
                                      <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].update`}
                                            value={
                                              formik.values.modules[index]
                                                .update
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> Update
                                        </label>
                                      </td>
                                      <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].delete`}
                                            value={
                                              formik.values.modules[index]
                                                .delete
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> Delete
                                        </label>
                                      </td>
                                     { formik.values.modules[index].module_name == 251 &&(
                                    <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].other_1`}
                                            value={
                                              formik.values.modules[index]
                                                .other_1
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> Fixed 
                                        </label>
                                      </td>
                                     )}
                                     
                                     
                                      { formik.values.modules[index].module_name == 251 &&(
                                        <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].other_2`}
                                            value={
                                              formik.values.modules[index]
                                                .other_2
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> Saisonal
                                        </label>
                                      </td>
                                      )}
                                     
                                     
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />     
                      <small>
                        
                        {backendErrors.status  && (
                              <span className="form-error mt-1">
                                {backendErrors.status}
                              </span>
                            )}
                    </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={formik.isSubmitting}
                        >
                          Add User
                        </button>
                      </div>
                    </form>
                    </FormikProvider>
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddUser;
